export default __webpack_public_path__ + "static/media/guide0104.ff1f057b.jpg";